"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Deferred {
    constructor(defaultVal = null) {
        this.state = 'pending';
        this.fate = 'unresolved';
        this._val = defaultVal || null;
        this.promise = new Promise((resolve, reject) => {
            this._resolve = resolve;
            this._reject = reject;
        });
        this.promise.then((val) => {
            this.state = 'fulfilled';
            this._val = val;
        }, () => {
            this.state = 'rejected';
            this._val = null;
        });
    }
    resolve(value) {
        if (this.fate === 'resolved') {
            throw 'Deferred cannot be resolved twice';
        }
        this.fate = 'resolved';
        this._resolve(value);
    }
    reject(reason) {
        if (this.fate === 'resolved') {
            throw 'Deferred cannot be resolved twice';
        }
        this.fate = 'resolved';
        this._reject(reason);
    }
    isResolved() {
        return this.fate === 'resolved';
    }
    isPending() {
        return this.state === 'pending';
    }
    isFulfilled() {
        return this.state === 'fulfilled';
    }
    isRejected() {
        return this.state === 'rejected';
    }
    get val() {
        return this._val;
    }
}
exports.default = Deferred;
//# sourceMappingURL=Deferred.js.map